import React, { useState, useEffect } from 'react';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import { Button } from 'primereact/button';

import { ModalEditarEmpresa } from './ModalEditarEmpresa';
import { ModalEliminarEmpresa } from './ModalEliminarEmpresa';
import { ModalEditarCertificadosEmpresa } from './ModalEditarCertificadosEmpresa';
import servicioHttp from '../../servicio/ServicioHttp';
import servicioObjetos from '../../servicio/ServicioObjetos';
import servicioFormatos from '../../servicio/ServicioFormatos';

const JOIN_PRINCIPAL = {

};
const PAGINACION_INICIAL = {
    registrosPorPagina: 10,
    join: null,
    restriccionesDinamicas: [
    ],
    ordenamientos: [
        {
            tipo: "asc",
            nombrePropiedad: "fechaExpiracion"
        }
    ]
};

export const Tabla = (props) => {

    const { restriccionesBusqueda } = props;
    const [paginacion, setPaginacion] = useState(PAGINACION_INICIAL);
    const [inicio, setInicio] = useState(0);
    const [empresa, setEmpresa] = useState({});
    const [mostrarModal, setMostrarModal] = useState(false);
    const [mostrarModalEliminar, setMostrarModalEliminar] = useState(false);
    const [mostrarModalEditarCerts, setMostrarModalEditarCerts] = useState(false);

    const mostrarModalEditar = (empresaEditar) => {
        setMostrarModal(true);
        setEmpresa(empresaEditar);
    }

    const cerrarModalEditar = (valor) => {
        setMostrarModal(valor);
        obtenerEmpresa();
    }

    const mostrarModalDelete = (empresaEliminar) => {
        setMostrarModalEliminar(true);
        setEmpresa(empresaEliminar);
    }

    const cerrarModalEliminar = () => {
        obtenerEmpresa();
        setMostrarModalEliminar(false);
    }

    const mostrarModalCerts = (empresaCerts) => {
        setEmpresa(empresaCerts);
        setMostrarModalEditarCerts(true);
    }

    const cerrarModalCerts = () => {
        setMostrarModalEditarCerts(false);
        obtenerEmpresa();
    }


    useEffect(() => {
        obtenerEmpresa();
    }, [restriccionesBusqueda]);

    const obtenerEmpresa = () => {
        asignarRestricciones();
        servicioHttp.consumirPostHttp("empresa/consultar.json", paginacion).then(response => {
            setPaginacion(response.data.objeto);
        }).catch(e => console.error(e));
    }

    const onIndexTemplate = (data, props) => {
        return (props.rowIndex + 1) + inicio;
    }

    const plantillaCarga = (rowData, column) => {
        return <div className="p-grid">
            <div className="p-col-12 p-md-4">
                <Button
                    type="button"
                    icon="pi-md-save"
                    onClick={(e) => mostrarModalCerts(column.rowData)}
                    className="guardar"
                    name="cargar certificado"
                    tooltip="Cargar certificado" >
                </Button>
            </div>
        </div>;
    }

    const columnaFecha = (rowData, column) => {
        return <div>{servicioFormatos.formatearFecha(rowData.fechaExpiracion)}</div>;
    }

    const columnaEstatus = (rowData, column) => {
        if (rowData.estado === 0)
            return <p style={{ backgroundColor: '#ff9f00', borderWidth: 1, borderColor: '#000', borderRadius: 12, padding: 8 }}>Activo</p>;
        if (rowData.estado === 1)
            return <p style={{ backgroundColor: '#f008', borderWidth: 1, borderColor: '#000', borderRadius: 12, padding: 8 }}>Inactivo</p>;
        if (rowData.estado === 2)
            return <p style={{ backgroundColor: '#f008', borderWidth: 1, borderColor: '#000', borderRadius: 12, padding: 8 }}>Revocado</p>;
    }

    const plantillaOpciones = (rowData, column) => {
        return <div className="p-grid">

            <div className="p-col-12 p-md-6">
                <Button
                    type="button"
                    icon="pi-md-edit"
                    onClick={(e) => mostrarModalEditar(column.rowData)}
                    className="p-button-warning"
                    name="Editar"
                    tooltip="Editar">
                </Button>
            </div>
            <div className="p-col-12 p-md-6">
                <Button
                    type="button"
                    icon={rowData.estado === 0 ? "pi-md-lock" : "pi-md-lock-open"}
                    onClick={(e) => mostrarModalDelete(column.rowData)}
                    className="p-button-danger"
                    name={rowData.estado === 0 ? "Desactivar" : "Activar"}
                    tooltip={rowData.estado === 0 ? "Desactivar" : "Activar"} >
                </Button>
            </div>
        </div>;
    }

    const cambiaPagina = (event) => {
        asignarRestricciones();
        paginacion.numeroPagina = event.page;
        paginacion.registrosPorPagina = event.rows;
        setInicio(event.first);
        obtenerEmpresa();
    }

    const asignarRestricciones = () => {
        paginacion.join = JOIN_PRINCIPAL;
        paginacion.restriccionesDinamicas = [];
        if (!servicioObjetos.esObjetoVacio(restriccionesBusqueda.registroPatronal)) {
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: "eq",
                nombrePropiedad: "registroPatronal",
                valorPropiedad: restriccionesBusqueda.registroPatronal
            });
        }
        if (!servicioObjetos.esObjetoVacio(restriccionesBusqueda.razonSocial)) {
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: "eq",
                nombrePropiedad: "razonSocial",
                valorPropiedad: restriccionesBusqueda.razonSocial
            });
        }
        if (!servicioObjetos.esObjetoVacio(restriccionesBusqueda.rfc)) {
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: "eq",
                nombrePropiedad: "rfc",
                valorPropiedad: restriccionesBusqueda.rfc
            });
        }
        if (!servicioObjetos.esObjetoVacio(restriccionesBusqueda.representanteLegal)) {
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: "eq",
                nombrePropiedad: "representanteLegal",
                valorPropiedad: restriccionesBusqueda.representanteLegal
            });
        }
        if (!servicioObjetos.esObjetoVacio(restriccionesBusqueda.actividadEconomica)) {
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: "eq",
                nombrePropiedad: "actividadEconomica",
                valorPropiedad: restriccionesBusqueda.actividadEconomica
            });
        }
        if (!servicioObjetos.esObjetoVacio(restriccionesBusqueda.estado)) {
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: "eq",
                nombrePropiedad: "estado",
                valorPropiedad: restriccionesBusqueda.estado.value
            });
        }
    }

    return (
        <div className="card card-w-title">
            <DataTable
                value={paginacion.datos}
                responsive={true}
                header="Empresa"
                autoLayout={true}>
                <Column field="Index" header="Número" body={onIndexTemplate} />
                <Column field="registroPatronal" header="Registro Patronal" />
                <Column field="razonSocial" header="Razón Social" />
                <Column field="nombreCortoRazonSocial" header="Nombre corto razón social" />
                <Column field="rfc" header="RFC" />
                <Column body={columnaFecha} header="Fecha Expiracion" />
                <Column body={columnaEstatus} header="Estado" />
                <Column header="Opciones" body={plantillaOpciones} />
                <Column header="" body={plantillaCarga} />
            </DataTable>
            <Paginator first={inicio} rows={paginacion.registrosPorPagina} totalRecords={paginacion.registrosTotales}
                onPageChange={cambiaPagina} rowsPerPageOptions={[10, 20, 40, 60, 80, 100]}
                template="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
                currentPageReportTemplate={"Total: " + paginacion.registrosTotales + ", Página ({currentPage} de {totalPages})"} />
            <ModalEditarEmpresa empresaEditar={empresa} mostrarModal={mostrarModal} funcionCerrarModal={cerrarModalEditar} />
            <ModalEliminarEmpresa empresaEliminar={empresa} mostrarModal={mostrarModalEliminar} funcionCerrarModal={cerrarModalEliminar} />
            <ModalEditarCertificadosEmpresa empresaEditar={empresa} mostrarModal={mostrarModalEditarCerts} funcionCerrarModal={cerrarModalCerts} />
        </div>
    );
}